import React from 'react';
import './MallCard.css';

const MallCard = ({ itemid, imageUrl, price, name, companyName, location }) => {
  let itemUrl = "https://www.360ep.cn/mall/show.php?itemid=" + itemid;
  return (
    <div className="mall-card">
      <div className="mall-pic">
        <a href={itemUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={imageUrl}  
            alt={name}
            style={{width: '100%', height: '100%'}}         
          />
        </a>
      </div>
      <div className="mall-price">￥<span>{price}</span>件</div>      
      <div className="mall-name">{name}</div>
      <div className="mall-company">
        <div className="commpany-name">{companyName}</div>
        <div className="commpany-credit"><img src="https://www.360ep.cn/skin/360ep/image/v_company.gif" alt={companyName} />0年<span>真实性未核验</span>        
        </div>
      </div>
      <div className="mall-chat">
        <div className="mall-area">供应地：{location}</div>
        <div><a href="https://www.360ep.cn/member/chat.php?touser=baifeng&amp;mid=36&amp;itemid=9969" target="_blank" rel="noopener noreferrer nofollow">
              <img src="https://wpa.qq.com/pa?p=1:2865036506:4" title="点击交谈/留言" alt="" align="absmiddle"/>
            </a></div>
      </div>        
    </div>
  );
};

export default MallCard;
